import * as React from "react";
import { Link } from "react-router-dom";
import { useCountUp } from "@/hooks/use-count-up";
import { euro, numero } from "@/lib/format";
import { cn } from "@/lib/utils";

/* Il numero da solo (pacchetto del 29-10): etichetta sopra, numero in Archivo, sotto il confronto con un
   periodo che ha un nome. size="hero" solo per il numero che apre la dashboard. Il rosso arriva solo
   quando c'è da fare qualcosa (tone="danger"). */
export function KpiTile({ label, value, format = "euro", detail, tone = "default", size = "display", bare = false, href, className }) {
  const v = useCountUp(value);
  const fmt = (n) => (format === "euro" ? euro(n) : numero(n));
  const danger = tone === "danger";
  const Comp = href ? Link : "div";
  return (
    <Comp
      to={href}
      className={cn(
        "flex flex-col gap-1",
        !bare && "rounded-xl border p-4 md:p-5",
        !bare && (danger ? "border-danger-line bg-danger-bg" : "border-line bg-surface"),
        href && "transition-colors duration-150 ease-enter hover:bg-surface-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand",
        className,
      )}
    >
      <span className={cn(danger ? "font-semibold text-danger-ink" : "text-ink-2")}>{label}</span>
      {/* il lettore di schermo legge il valore finale, non i passaggi */}
      <span aria-hidden="true" className={cn("font-figure", size === "hero" ? "text-hero" : "text-display", danger ? "text-danger-ink" : "text-ink-strong")}>
        {fmt(v)}
      </span>
      <span className="sr-only">{fmt(value)}</span>
      {detail && <span className={cn("tabular-nums", danger ? "text-danger-ink" : "text-ink-2")}>{detail}</span>}
    </Comp>
  );
}
